module.exports = __webpack_public_path__ + "static/dbz-avatar-d5032b935f5e8786b9616c35e8ac54dc.jpg";